import script from "./TestWindowItem.vue?vue&type=script&setup=true&lang=js"
export * from "./TestWindowItem.vue?vue&type=script&setup=true&lang=js"

import "./TestWindowItem.vue?vue&type=style&index=0&id=24f753c0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24f753c0"]])

export default __exports__